module.exports = __webpack_public_path__ + "img/SGD.1ddeea9a.png";